module.exports = __webpack_public_path__ + "img/skinny.d23c1928.png";